import { FETCH_ACTIONS } from './actions';
const convertEpochTimeToLocaleString = (timestamp) => {
    const asDate = new Date(timestamp);
    return asDate.toISOString();
};
export const reportIfTokenExpired = (accessToken, logger) => {
    const payload = accessToken.split('.')[1];
    const parsedToken = JSON.parse(atob(payload));
    const expiry = parsedToken?.exp ? parsedToken.exp : undefined;
    const now = Date.now();
    if (expiry && expiry * 1000 <= now) {
        try {
            const message = `attempting to make request at ${convertEpochTimeToLocaleString(now)}, with invalid token expired at ${convertEpochTimeToLocaleString(expiry * 1000)}, token: ${accessToken}`;
            logger.track(FETCH_ACTIONS.expiredToken, {
                message,
            });
        }
        catch {
            // noop
        }
    }
};
